export default __webpack_public_path__ + "static/media/crossing-point.2850348d.svg";